import React from 'react'
import s from './Breadcrumbs.less'
import { useSelector } from 'react-redux'
import { selectBreadcrumbs } from '../../store/seo/seo.selectors'
import BreadcrumbItem from './BreadcrumbItem'

const Breadcrumbs = () => {
  const breadcrumbs = useSelector(selectBreadcrumbs)

  return (
    <div className={s.wrapper}>
      <ol itemScope={true} itemType="https://schema.org/BreadcrumbList" className={s.breadcrumbs}>
        {(breadcrumbs || []).map(({ labelKey, labelArgs, url }, idx) => (
          <BreadcrumbItem labelKey={labelKey} labelArgs={labelArgs} url={url} idx={idx} key={idx} />
        ))}
      </ol>
    </div>
  )
}

export default Breadcrumbs
